import { Injectable, inject } from '@angular/core';
import {
    UserPositionDto,
    UserPositionExitCleanupTask,
} from '@pf/platform-core/domain';
import { PickListDataService } from '@pf/platform-wms/domain';
import { asArraySafe } from '@pf/shared-utility';
import { Observable, of } from 'rxjs';
import { PickingContext } from '../../models/picking-context.model';
import { CpwUserPositionTypes } from '../../UserPositionTypes';

@Injectable({ providedIn: 'root' })
export class PickingPositionExitCleanupTask
    implements UserPositionExitCleanupTask
{
    readonly id = 'picking-unclaim';

    private readonly pickListDataService = inject(PickListDataService);

    appliesTo(position: UserPositionDto): boolean {
        if (position.userPositionTypeName !== CpwUserPositionTypes.Picking) {
            return false;
        }
        const ctx = position.context as PickingContext | undefined;
        return !!asArraySafe(ctx?.pickListIds).length && !!ctx?.warehouseId;
    }

    cleanup$(position: UserPositionDto): Observable<unknown> {
        const ctx = position.context as PickingContext | undefined;
        const warehouseId = ctx?.warehouseId;
        const pickListIds = asArraySafe(ctx?.pickListIds);
        if (!warehouseId || !pickListIds.length) return of(null);
        return this.pickListDataService.unClaimPicklists$(
            warehouseId,
            pickListIds
        );
    }
}
